module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tabs product-list"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n        " + _vm._s(_vm.tableData.length) + "种产品" + _vm._s(_vm.totalProducts) + "件\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "inline-item"
  }, [_vm._v("\n        退货总计："), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.others.totalProdcutMoney))]), _vm._v("元\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品名称",
      "width": "190",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.productName || '--'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "productNo",
      "label": "产品编号",
      "width": "90",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品条码",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.barcode || '--'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "规格",
      "width": "90",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.specification || '--') + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "num",
      "label": "数量",
      "width": "70",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "width": "80",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.memo || '--') + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "单位",
      "width": "60",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.unit || '--') + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "productPrice",
      "label": "采购价 (元)",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89a1cf3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/returned-purchase/product-list.vue
// module id = 1315
// module chunks = 82